<div class="panel panel-default">
    <div class="panel-heading">
        <div class="panel-title">Billing Overview</div>
    </div>
    <div class="panel-body">
        <div *ngIf="!isLoaded" class="whirl standard spinnermargin"></div>
        <ng-template [ngIf]="isLoaded">
            <!-- Recent Statements -->
            <div *ngIf="statements.length > 0">
                <p class="text-semibold mb-sm">Recent Statement Items</p>
                <div class="table-responsive">
                    <table class="table table-striped table-sm mb-lg">
                        <thead>
                            <tr>
                                <th>Description</th>
                                <th>Category</th>
                                <th>Org</th>
                                <th class="text-right">Amount</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let s of statements">
                                <td>{{ s.description }}</td>
                                <td>{{ s.category }}</td>
                                <td>{{ s.org_name }}</td>
                                <td class="text-right">{{ s.amount_formatted || s.amount }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div *ngIf="statements.length === 0" class="text-center text-muted py-lg">
                No recent billing statements.
            </div>

            <!-- Monthly Totals -->
            <div *ngIf="monthlyBilling.length > 0">
                <p class="text-semibold mb-sm">Monthly Billing Totals (12 months)</p>
                <div class="table-responsive">
                    <table class="table table-striped table-sm">
                        <thead>
                            <tr>
                                <th>Month</th>
                                <th class="text-right">Total</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let m of monthlyBilling">
                                <td>{{ m.month }}</td>
                                <td class="text-right">{{ m.total_formatted || m.total }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </ng-template>
    </div>
</div>